export const getPageTitle = (pathname) => {
    switch (pathname) {
        case '/':
            return 'Dashboard';
        case '/login':
            return 'Login';
        case '/categories':
            return 'Categories';
        case '/dashboard':
            return 'Dashboard';
        case '/users':
            return 'Users';
        case '/subscriptions':
        case '/subscription':
            return 'Subscription';
        case '/folders':
            return 'Categories';
        case '/products':
            return 'Products';
        case '/industries':
            return 'Industries';
        case '/clients':
            return 'Clients';
        case '/tags':
            return 'Tags';
        case '/application-images':
        case '/applicationImages':
            return 'Application Images';
        case '/analytics':
            return 'Analytics';
        case '/settings':
            return 'Settings';
        case '/activity-log':
            return 'Activity Log';
        case '/enquiries':
            return 'Enquiries';
        case '/profile':
            return 'My Profile';
        default:
            if (pathname.startsWith('/applicationImages/view/')) {
                return 'Application Image Details';
            }
            if (pathname.startsWith('/enquiries/view/')) {
                return 'Enquiry Details';
            }
            const last = pathname.split('/').filter(Boolean).pop();
            return last ? last.charAt(0).toUpperCase() + last.slice(1) : '';
    }
};
